"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { button, text } from '../styles.js';
import { Box } from '../../Box/Box.web.js';
import { renderComponentOrElement } from '../../utils/helpers/component.js';
import { useTheme } from '../../utils/theming/useTheme.js';

var _excluded = ["item", "onClick", "isActive", "color", "stretchOnMobile", "onKeyDown", "size", "variant", "activeIcon"];
var ContentSwitcherTab = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var item = props.item,
    onClick = props.onClick,
    isActive = props.isActive,
    color = props.color,
    stretchOnMobile = props.stretchOnMobile,
    onKeyDown = props.onKeyDown,
    size = props.size,
    variant = props.variant,
    activeIcon = props.activeIcon,
    rest = _objectWithoutProperties(props, _excluded);
  var handleClick = React.useCallback(function (e) {
    // istanbul ignore else -- sanity, should be avoided by having disabled in the button
    if (!item.disabled) {
      onClick(e, item.id);
    }
  }, [item, onClick]);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(button, _extends({
    $active: isActive,
    "aria-controls": String(item.id),
    "aria-selected": isActive,
    tabIndex: isActive ? 0 : -1,
    id: "".concat(item.id, "-tab"),
    onClick: handleClick,
    onKeyDown: onKeyDown,
    role: "tab",
    $color: color,
    $stretchOnMobile: stretchOnMobile,
    disabled: item.disabled,
    ref: ref,
    theme: theme,
    $size: size,
    $variant: variant
  }, rest), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    height: "100%"
  }, isActive && activeIcon && renderComponentOrElement(activeIcon, {
    size: 24
  }), /*#__PURE__*/React.createElement(text, {
    $useActiveIcon: Boolean(activeIcon) && isActive
  }, item.name)));
});
ContentSwitcherTab.displayName = 'ContentSwitcherTab';

export { ContentSwitcherTab };
